import { gsap } from '../animations';

/**
 * Impression GA4 view_item_list: alla prima entrata della griglia nel viewport,
 * push dell'elenco offerte mostrate. Indipendente da reduced-motion (è tracking,
 * non animazione) → registrata prima del guard.
 */
function trackListImpression( block ) {
	const cards = block.querySelectorAll( '[data-tm-offer-id]' );
	if ( ! cards.length ) {
		return;
	}

	const observer = new IntersectionObserver( ( entries, obs ) => {
		entries.forEach( ( entry ) => {
			if ( ! entry.isIntersecting ) {
				return;
			}
			obs.disconnect();
			window.dataLayer = window.dataLayer || [];
			window.dataLayer.push( {
				event: 'view_item_list',
				item_list_name: 'Offerte',
				items: Array.from( cards ).map( ( c, i ) => ( {
					item_id: c.dataset.tmOfferId,
					item_name: c.dataset.tmOfferName || '',
					item_category: 'offerta',
					index: i + 1,
				} ) ),
			} );
		} );
	}, { threshold: 0.25 } );

	observer.observe( block );
}

/**
 * Animazioni d'ingresso del block "Offerte — Griglia":
 * - intestazione (eyebrow/titolo/testo) in fade-up a stagger;
 * - card in fade-up a stagger all'ingresso della griglia.
 * Con reduced-motion resta tutto fermo e visibile (niente gsap.from).
 */
export function initOfferteGriglia() {
	// Impression tracking: sempre, anche con reduced-motion.
	document.querySelectorAll( '[data-tm-offerte]' ).forEach( trackListImpression );

	if ( window.matchMedia( '(prefers-reduced-motion: reduce)' ).matches ) {
		return;
	}

	document.querySelectorAll( '[data-tm-offerte]' ).forEach( ( block ) => {
		const head = block.querySelector( '[data-tm-offerte-head]' );
		if ( head && head.children.length ) {
			gsap.from( head.children, {
				y: 24,
				opacity: 0,
				duration: 0.7,
				ease: 'power3.out',
				stagger: 0.1,
				scrollTrigger: { trigger: head, start: 'top 84%', once: true },
			} );
		}

		const list = block.querySelector( 'ul' );
		const cards = list ? list.querySelectorAll( ':scope > li' ) : [];
		if ( ! cards.length ) {
			return;
		}

		gsap.from( cards, {
			y: 28,
			opacity: 0,
			duration: 0.6,
			ease: 'power3.out',
			stagger: 0.08,
			scrollTrigger: { trigger: list, start: 'top 82%', once: true },
		} );
	} );
}
